import { render, staticRenderFns } from "./CreateOrUpdateProduct.vue?vue&type=template&id=c001a062&"
import script from "./CreateOrUpdateProduct.vue?vue&type=script&lang=ts&"
export * from "./CreateOrUpdateProduct.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./CreateOrUpdateProduct.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports